<template>
  <div class="slider__controller" ref="slider">
    <div class="slider__progress"></div>
    <div class="slider__bar" :style="barStyle"></div>
    <div
      class="slider__button-wrapper"
      :style="wrapperStyle"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousedown="onButtonDown"
      @touchstart="onButtonDown"
      :class="{ 'hover': hovering, 'dragging': dragging }"
      ref="button"
      tabindex="0"
      @focus="handleMouseEnter"
      @blur="handleMouseLeave"
      @keydown.left="onLeftKeyDown"
      @keydown.right="onRightKeyDown"
      @keydown.down.prevent="onLeftKeyDown"
      @keydown.up.prevent="onRightKeyDown"
    >
      <div :disabled="!showTooltip">
        <span>{{ formatValue }}</span>
        <div class="slider__button" :class="{ 'hover': hovering, 'dragging': dragging }">
          <div class="slider__button-bubble"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
export default {
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTooltip: false,
      hovering: false,
      dragging: false,
      isClick: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.modelValue,
      sliderSize: 1,
    }
  },

  computed: {
    formatValue() {
      // return (
      //   (this.enableFormat && this.$parent.formatTooltip(this.modelValue)) ||
      //   this.modelValue
      // )
    },
    precision() {
      let precisions = [this.min, this.max, this.step].map((item) => {
        let decimal = ('' + item).split('.')[1]
        return decimal ? decimal.length : 0
      })
      return Math.max.apply(null, precisions)
    },
    wrapperStyle() {
      return { left: this.currentPosition }
    },
    currentPosition() {
      return `${((this.modelValue - this.min) / (this.max - this.min)) * 100}%`
    },
    barStyle() {
      return { width: this.currentPosition }
    },
  },

  watch: {
    dragging(val) {
      this.$parent.dragging = val
    },
  },
  emits: ['update:modelValue'],
  methods: {
    resetSize() {
      if (this.$refs.slider) {
        this.sliderSize = this.$refs.slider['clientWidth']
      }
    },
    displayTooltip() {
      this.showTooltip = true
    },

    hideTooltip() {
      this.showTooltip = false
    },

    handleMouseEnter() {
      this.hovering = true
      this.displayTooltip()
    },

    handleMouseLeave() {
      this.hovering = false
      this.hideTooltip()
    },

    onButtonDown(event) {
      if (this.disabled) return
      event.preventDefault()
      this.onDragStart(event)
      window.addEventListener('mousemove', this.onDragging)
      window.addEventListener('touchmove', this.onDragging)
      window.addEventListener('mouseup', this.onDragEnd)
      window.addEventListener('touchend', this.onDragEnd)
      window.addEventListener('contextmenu', this.onDragEnd)
    },
    onDragStart(event) {
      this.dragging = true
      this.isClick = true
      if (event.type === 'touchstart') {
        event.clientY = event.touches[0].clientY
        event.clientX = event.touches[0].clientX
      }

      this.startX = event.clientX
      this.startPosition = parseFloat(this.currentPosition)
      this.newPosition = this.startPosition
    },

    onDragging(event) {
      if (this.dragging) {
        this.isClick = false
        this.displayTooltip()
        this.resetSize()
        let diff = 0
        if (event.type === 'touchmove') {
          event.clientY = event.touches[0].clientY
          event.clientX = event.touches[0].clientX
        }

        this.currentX = event.clientX
        // diff = (this.currentX - this.startX)
        diff = (this.currentX - this.startX) / this.sliderSize * 100;
        this.newPosition = this.startPosition + diff
        this.setPosition(this.newPosition)
      }
    },

    onDragEnd() {
      if (this.dragging) {
        /*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */
        setTimeout(() => {
          this.dragging = false
          this.hideTooltip()
          if (!this.isClick) {
            this.setPosition(this.newPosition)
          }
        }, 0)
        window.removeEventListener('mousemove', this.onDragging)
        window.removeEventListener('touchmove', this.onDragging)
        window.removeEventListener('mouseup', this.onDragEnd)
        window.removeEventListener('touchend', this.onDragEnd)
        window.removeEventListener('contextmenu', this.onDragEnd)
      }
    },

    setPosition(newPosition) {
      if (newPosition === null || isNaN(newPosition)) return
      if (newPosition < 0) {
        newPosition = 0
      } else if (newPosition > 100) {
        newPosition = 100
      }
      const lengthPerStep = 100 / ((this.max - this.min) / this.step)
      const steps = Math.round(newPosition / lengthPerStep)
      let value =
        steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min
      value = parseFloat(value.toFixed(this.precision))
      this.$emit('update:modelValue', value)
      nextTick(() => {
        this.displayTooltip()
      })
      if (!this.dragging && this.modelValue !== this.oldValue) {
        this.oldValue = this.modelValue
      }
    },
  },
}
</script>

<style lang="less" scoped>
.slider__controller {
  position: relative;
  width: 100%;
  height: 48px;
  user-select: none;
}
.slider__progress {
  width: 100%;
  height: 6px;
  background: #eeeeee;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 21px;
  z-index: 1;
}
.slider__bar {
  width: 0;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(90deg, #ff8e00 0%, #ff5500 100%);
  position: absolute;
  left: 0;
  top: 21px;
  z-index: 2;
}
.slider__button-wrapper {
  position: absolute;
  height: 48px;
  width: 48px;
  z-index: 9;
  top: 0px;
  transform: translateX(-50%);
  background-color: transparent;
  text-align: center;
  user-select: none;
  line-height: normal;
}
.slider__button {
  width: 28px;
  height: 28px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(217, 72, 0, 0.5);
  border-radius: 50%;
  -webkit-transition: left 0.2s;
  transition: left 0.2s;
  user-select: none;
  position: absolute;
  top: 10px;
  left: 10px;
}
.slider__button-bubble {
  width: 20px;
  height: 20px;
  background: #ff5500;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>